import { render, staticRenderFns } from "./hub.vue?vue&type=template&id=3720e9ff&"
import script from "./hub.vue?vue&type=script&lang=js&"
export * from "./hub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports